<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: Array,
            field: String,

            labelWidth: String,
            type: String,
            typeValue: [String, Number],
            typeField: String,
            typeDisabled: {
                type: Boolean,
                default: false,
            },

            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: ''
            }
        },
        methods: {
            change_value(v) {
                this.$emit('input', v);
                this.$emit('change', v);
                if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            change_type(v) {
                this.$emit('input-type', v);
                this.$emit('update:typeValue', v);
                this.$emit('change-type', v);
                if (this.typeField) {
                    this.$emit('change-type-field', {
                        field: this.typeField,
                        value: v,
                    });
                }
            },
            input_type(v) {
                this.$emit('input-type', v);
                this.$emit('update:typeValue', v);
                if (this.typeField) {
                    this.$emit('input-type-field', {
                        typeField: this.typeField,
                        value: v,
                    });
                }
            },
        },
        computed: {
            list() {
                return this.items ? this.items(this.type) : [];
            },
            ...mapGetters('dictionaries/dates', {
                items: 'list'
            }),
        },
        watch: {},
        mounted() {
        },

        components: {},
    }
</script>
<template>
    <form-dates
            class="dictionary dictionary-dates-and-type"
            :label-width="labelWidth"
            :labelOptions="list"
            :labelValue="typeValue"
            @change-label="change_type"
            @input-label="input_type"
            :value="value"
            @input="input_value"
            :disabled="disabled"
            :clearable="clearable"
            :labelDisabled="typeDisabled || disabled"
            @change="change_value">
    </form-dates>
</template>
<style lang="scss">
</style>
